export default __webpack_public_path__ + "static/award_img-b6bc695b1acfb59c17676618cff1a4d5.png";